module.exports = __webpack_public_path__ + "static/ambient-2821e486db7c5ae4378efaf4ee4cbe6f.mp3";